import React from "react";
import styles from "./story.module.css";
import { Heading, Paragraph } from "../TextComponents/TextComponents";
import { Container } from "react-bootstrap";
import Timeline from "../Timeline/Timeline";

const Story = () => {
  return (
    <React.Fragment>
      <Container>
        <div className={styles.section}>
          <Heading>
            Our Story: From Humble Beginnings <br /> to Global Impact
          </Heading>
          <Paragraph>
            Tracing our journey of growth, innovation, and excellence in global
            trade.
          </Paragraph>

          <Timeline />
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Story;
